import {assert, is, object} from "@typesec/the";
import type {IClientProtocol, ProtocolRequest, ProtocolResponse} from "../interfaces.mjs";
import {ClientURLStore} from "./ClientURLStore.mjs";

export class ClientFetchProtocol implements IClientProtocol {
    readonly #url: ClientURLStore;

    constructor(url: string | ClientURLStore) {
        this.#url = is(url, "string") ? new ClientURLStore(url) : url;
    }

    public async query(request: ProtocolRequest): Promise<ProtocolResponse> {
        const res = await fetch(this.#url.get(), {
            body: JSON.stringify(request.query),
            method: "POST",
            headers: {
                accept: "application/json",
                "content-type": "application/json",
            },
        });

        try {
            assert(res.status === 200, res.statusText ?? "Wrong status");

            const response = await res.json();
            assert(object.isPlain(response), "Wrong response");

            return {
                data: response.data,
                code: response.code,
                reason: response.reason,
            };
        } catch (reason) {
            return {
                code: res.status,
                data: null,
                reason: {
                    issues: [],
                    message: `${reason}`,
                },
            };
        }
    }
}
